export default __webpack_public_path__ + "static/media/team_bryant_ellie.f71d5f67.jpg";